// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"8c509b5c7b979cbf3ec9","678":"150c23661670697be83a","731":"af2369971012a1cc70e2","843":"6b2768d43fcfd44881ba","883":"e46bbfc1edd6c3beed87"}[chunkId] + ".js";
};